/*
* General worlflow configurator
* This is the basic workflow followed by all paid accounts (direct-buy, offline buy, etc)
* This workflow gets admins to enable/setup toll free for the account and other users to
* set up the list of countries for toll and toll free
*/
define('setup/configurators/general-wf-configurator',['require','i18next','lodash','./configurator'],function (require) {
    var i18n = require('i18next');
    var _ = require('lodash');
    var configurator = require('./configurator');

    function DirectBuyConfigurator(options) {
        this.options = _.cloneDeep(options);
    }

    // we are implementing the configurator interface
    DirectBuyConfigurator.prototype = Object.create(configurator);

    DirectBuyConfigurator.prototype.setCompleteUrl = function (url) {
        this.options.completeUrl = url;
    };

    DirectBuyConfigurator.prototype._getTotalSteps = function () {
        var canManageSettings = this.options.canManageSettings;
        var isTFProvisionedAndDisabled = this.options.isTollFreeProvisioned &&
            !(this.options.isTollFreeAccessible && this.options.isTollFreeEnabled);
        var hasSecondSetp = (canManageSettings && isTFProvisionedAndDisabled) ||
            (this.options.userTollFreeProvisioned || this.options.userTollProvisioned);

        return hasSecondSetp ? 2 : 1;
    };

    DirectBuyConfigurator.prototype._getSecondStepUrl = function () {
        var TFPage = '#setup/admin-audio';
        var AudioPage = '#setup/default-numbers';
        var secondStep;
        var canManageSettings = this.options.canManageSettings;
        var isTFProvisionedAndDisabled = this.options.isTollFreeProvisioned &&
            !(this.options.isTollFreeAccessible && this.options.isTollFreeEnabled);
        var adminAudioSetup = !!this.options.adminAudioOnboardingViewed;

        if (!adminAudioSetup && canManageSettings && isTFProvisionedAndDisabled && !this.options.extAdminDown) {
            secondStep = TFPage;
        } else if (this.options.userTollFreeProvisioned || this.options.userTollProvisioned) {
            secondStep = AudioPage;
        } else {
            secondStep = this.options.completeUrl;
        }

        return secondStep;
    };

    DirectBuyConfigurator.prototype.get = function () {
        var pageDesc = function (totalSteps, currentStep, descKey) {
            return (totalSteps > 1 ? i18n.t('setup.common.step', currentStep) : '') +
                i18n.t(descKey);
        };

        var secondStep = this._getSecondStepUrl();
        var totalSteps = this._getTotalSteps();
        var initialPage = 'setup/reserve-g2mm';

        if (this.options.goToMeetMeDown) {
            initialPage = (secondStep || '').replace('#setup', 'setup');
            totalSteps--;
        }

        if (this.options.reserveOnly) {
            totalSteps = 1;
        }

        return {
            workflowName: 'general-workflow',
            initialPage: initialPage,
            totalSteps: totalSteps,
            isG2MMSchedulingTest: this.options.isG2MMSchedulingTest,

            'reserve-g2mm': {
                currentStep: 1,
                pageDescription: pageDesc(totalSteps, 1, 'setup.reserveG2mm.personalMeetingPage'),
                nextUrl: secondStep,
                backUrl: null
            },

            'default-numbers': {
                currentStep: totalSteps,
                pageDescription: pageDesc(totalSteps, totalSteps, 'setup.default-numbers.title'),
                nextUrl: this.options.completeUrl,
                backUrl: totalSteps > 1 ? '#setup/reserve-g2mm' : ''
            },

            'admin-audio': {
                currentStep: totalSteps,
                pageDescription: pageDesc(totalSteps, totalSteps, 'setup.admin-toll-free.title'),
                nextUrl: this.options.completeUrl,
                backUrl: totalSteps > 1 ? '#setup/reserve-g2mm' : ''
            }
        };
    };

    return DirectBuyConfigurator;
});


